import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  InputLabel,
  ListItemText,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_SITE_TYPES,
  SAVE_POST_PICTURE,
  SAVE_POSTS,
  SAVE_PROJECTS_COMPAINES,
  SAVE_PROJECTS_PRODUCTS,
  SAVE_SITES,
  SAVE_USER_SITES_PROJECTS
} from "../../constant/Apipath";
import { validateURL } from "./Removeduplicate";
import moment from "moment";
import PromptModal from "./PromptModal";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import {
  setProjectimages,
  setSelectedProjectdata,
  setShowaddexperience,
  setShowaddproject,
  setShowmapmodal,
  setSiteprojects
} from "../../redux/actions/actions";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import ImageIcon from "@mui/icons-material/Image";
import { English } from "../../constant/EnglishFallback";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxWidth: ITEM_HEIGHT + ITEM_PADDING_TOP,
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: "auto"
    }
  },
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center"
  },
  variant: "menu"
};

export default function Addproject() {
  let getUrl = window.location.pathname.split("/").pop();
  const urlRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

  const {
    selectedSite,
    loginData,
    showAddproject,
    projectImages,
    showMapmodal,
    multiLanguageData
  } = useSelector((state) => state?.main);

  const initialProjectInfo = {
    siteId: 0,
    siteName: "",
    type: "",
    website: "",
    description: "",
    activeProject: false,
    addProfile: false,
    address: "",
    city: "",
    province: "",
    postalCode: "",
    country: "",
    latitude: 0,
    longitude: 0,
    projectName: ""
  };

  const [projectInfo, setProjectinfo] = useState(initialProjectInfo);
  const [imagelist, setImagelist] = useState([]);
  const [siteType, setSitetype] = useState([]);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    TEXT_SELECT_VALID_IMAGE = English?.AddProject?.TEXT_SELECT_VALID_IMAGE,
    TEXT_ENTER_VALID_URL_FORMAT = English?.AddProject?.TEXT_ENTER_VALID_URL_FORMAT,
    TEXT_PROJECT_NAME_SAME_AS_SITE = English?.AddProject?.TEXT_PROJECT_NAME_SAME_AS_SITE,
    TEXT_ADD_PROJECT = English?.AddProject?.TEXT_ADD_PROJECT,
    TEXT_ADD_PICTURES = English?.AddProject?.TEXT_ADD_PICTURES,
    TEXT_SITE_NAME_PLACEHOLDER = English?.AddProject?.TEXT_SITE_NAME_PLACEHOLDER,
    TEXT_NO_LOCATION = English?.AddProject?.TEXT_NO_LOCATION,
    TEXT_CHOOSE_SITE = English?.AddProject?.TEXT_CHOOSE_SITE,
    TEXT_OR = English?.AddProject?.TEXT_OR,
    TEXT_PROJECT_NAME_REQUIRED = English?.AddProject?.TEXT_PROJECT_NAME_REQUIRED,
    TEXT_TYPE = English?.AddProject?.TEXT_TYPE,
    TEXT_INPUT_LABEL_WEBSITE = English?.AddProject?.TEXT_INPUT_LABEL_WEBSITE,
    TEXT_ACTIVE_PROJECT = English?.AddProject?.TEXT_ACTIVE_PROJECT,
    TEXT_ADD_TO_MY_PROFILE = English?.AddProject?.TEXT_ADD_TO_MY_PROFILE,
    TEXT_DESCRIPTION = English?.AddProject?.TEXT_DESCRIPTION,
    BUTTON_TEXT_OK = English?.AddProject?.BUTTON_TEXT_OK
  } = multiLanguageData?.AddProject || {};

  useEffect(() => {
    if (showAddproject === true) {
      getInformation();
      getSitetypes();
      // dispatch(setShowaddproject(false));
    }
    return () => {
      setImagelist([]);
      setProjectinfo({
        siteId: 0,
        siteName: "",
        type: "",
        website: "",
        description: "",
        activeProject: false,
        addProfile: false,
        address: "",
        city: "",
        province: "",
        postalCode: "",
        country: "",
        latitude: 0,
        longitude: 0,
        projectName: ""
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAddproject, selectedSite]);

  const getSitetypes = async () => {
    try {
      let getObj = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{}],
        SortList: [{ FieldName: "Name", Direction: "ASC" }]
      };
      let sitesTypesRes = await Postrequestcall(FETCH_SITE_TYPES, getObj, loginData?.accessToken);
      if (sitesTypesRes.status === 200) {
        setSitetype(sitesTypesRes.data.data);
      }
    } catch (error) {
      console.log("getSitetypes-> Error When Fetching Site Types: ", error);
    }
  };

  const getInformation = () => {
    setProjectinfo({
      ...projectInfo,
      siteId: selectedSite?.id ?? 0,
      siteName: selectedSite?.name ?? "",
      latitude: selectedSite?.latitude ?? 0,
      longitude: selectedSite?.longitude ?? 0,
      address: selectedSite?.address ?? "",
      city: selectedSite?.city ?? "",
      province: selectedSite?.province ?? "",
      postalCode: selectedSite?.postalCode ?? "",
      country: selectedSite?.country ?? "",
      addProfile: showMapmodal?.from === "experience" ? true : false
    });
    // Project related images if coming from Map
    if (projectImages?.length > 0 && typeof projectImages !== "undefined") {
      setImagelist(projectImages ?? []);
    } else {
      setImagelist([]);
    }
  };

  function handleChooseFile(event) {
    const files = event.target.files;
    let allFilesValid = true;
    if (files?.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (!files[i].type.startsWith("image/")) {
          allFilesValid = false;
          break;
        }
      }
    }
    if (!allFilesValid) {
      return alert(`${TEXT_SELECT_VALID_IMAGE} (JPEG, PNG, GIF, etc.).`);
    }
    let images = [];
    for (let i = 0; i < files?.length; i++) {
      images.push(files[i]);
    }
    setImagelist([...imagelist, ...images]);
    event.target.value = null;
  }

  const onDeletePicturePressed = (picItem, picIndex) => {
    let updatePicturesList = imagelist.filter((item, index) => index !== picIndex);
    setImagelist(updatePicturesList);
  };

  const addSitechange = (e) => {
    let inputValue = e.target.value;
    if (e.target.name == "website") {
      let value = inputValue.trim();
      setProjectinfo({
        ...projectInfo,
        [e.target.name]: value
      });
    } else {
      const cleanedValue = (inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, ""));
      setProjectinfo({
        ...projectInfo,
        [e.target.name]: cleanedValue
      });
    }
  };

  const onCheckboxchange = (e) => {
    setProjectinfo({
      ...projectInfo,
      [e.target.name]: e.target.checked
    });
  };

  const onTypechange = (event) => {
    setProjectinfo({
      ...projectInfo,
      type: event?.target?.value
    });
  };

  const onSaveProject = async () => {
    try {
      if (projectInfo?.website !== "") {
        // Stop  if the website is not valid
        const isValidUrl1 = urlRegex.test(projectInfo?.website);
        // const isValidUrl1 = validateURL(projectInfo?.website);

        if (!isValidUrl1) {
          alert(TEXT_ENTER_VALID_URL_FORMAT);
          return;
        }
      }
      if (projectInfo?.siteName === "") {
        setConfirmationModalOpen(true);
        return;
      }
      setIsLoading(true);
      if (projectInfo?.siteId === 0) {
        // first add site then project
        await saveSitesAndProjects(
          projectInfo?.siteId,
          projectInfo?.projectName,
          projectInfo?.siteName
        );
      } else {
        if (projectInfo?.siteName.trim() === "") {
          const siteObj = {
            UserId: loginData?.userInformation?.UserId,
            ReturnRecordId: true,
            ReturnRecordError: true,
            SaveList: [
              {
                Id: projectInfo?.siteId,
                Name: projectInfo?.siteName,
                Address: projectInfo?.address,
                City: projectInfo?.address,
                Province: projectInfo?.address,
                PostalCode: projectInfo?.address,
                Country: projectInfo?.address,
                Latitude: projectInfo?.address,
                Longitude: projectInfo?.address,
                RecordStatusId: 1,
                ModifiedBy: loginData?.userInformation?.UserId
              }
            ]
          };
          await Postrequestcall(SAVE_SITES, siteObj, loginData?.accessToken);
        }
        await saveSitesAndProjects(
          projectInfo?.siteId,
          projectInfo?.projectName,
          projectInfo?.siteName
        );
      }
      if (showMapmodal?.from === "earn-rewards") {
        let mapModal = {
          open: false,
          from: "",
          select: ""
        };
        dispatch(setShowmapmodal(mapModal)); // Close map modal
      } else if (showMapmodal?.from === "company-detail" && !projectInfo?.addProfile) {
        let mapModal = {
          open: false,
          from: "",
          select: ""
        };
        dispatch(setShowaddproject(false));
        dispatch(setShowmapmodal(mapModal));
      }
    } catch (error) {
      console.log("onSaveProject-> Error When Saving Project: ", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const saveSitesAndProjects = async (siteId, projectName, siteName) => {
    let projectDetail;
    // Call "saveSites" API only when site id is zero or siteName is empty;
    if (siteId === 0 || siteName === "") {
      try {
        const siteObj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: 0,
              Name: siteName !== "" ? siteName : projectName,
              Address: projectInfo?.address ?? "",
              City: projectInfo.city ?? "",
              Province: projectInfo.province ?? "",
              PostalCode: projectInfo.postalCode ?? "",
              Country: projectInfo.country ?? "",
              Latitude: projectInfo?.latitude ?? 0,
              Longitude: projectInfo?.longitude ?? 0,
              RecordStatusId: 1,
              ModifiedBy: loginData?.userInformation?.UserId
            }
          ]
        };
        const saveSiteResult = await Postrequestcall(SAVE_SITES, siteObj, loginData?.accessToken);
        const projObj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: 0,
              UserId: loginData?.userInformation?.UserId,
              SiteId: siteId === 0 ? saveSiteResult?.data?.data[0]?.objData?.id : siteId,
              projectName: projectInfo?.projectName,
              ProjectType: projectInfo?.type === "" ? 0 : projectInfo?.type,
              ProjectWebsite: projectInfo?.website,
              Description: projectInfo?.description,
              IsActive: projectInfo?.activeProject,
              RecordStatusId: 1,
              ModifiedBy: loginData?.userInformation?.UserId
            }
          ]
        };
        const getResponse = await Postrequestcall(
          SAVE_USER_SITES_PROJECTS,
          projObj,
          loginData?.accessToken
        );

        if (!getResponse?.data?.status) {
          alert(getResponse?.data?.message ?? "Something went wrong. Please try again later.");
          return;
        }
        // if (getResponse?.status === 201) {
        projectDetail = getResponse?.data?.data[0]?.objData;
        let getObj = {
          ...getResponse?.data?.data[0]?.objData,
          projectId: getResponse?.data?.data[0]?.objData?.id,
          type: "add",
          from: showMapmodal?.from
        };
        dispatch(setSelectedProjectdata(getObj));
      } catch (error) {
        console.log(
          "saveSitesAndProjects-> Error When Saving Sites And Project: ",
          error?.response
        );
        alert(error?.response?.data?.message ?? "Something went wrong. Please try again later.");
      }
    } else {
      try {
        const projObj = {
          // <--- Comes in if when site id is not zero and site name is not empty;
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: 0,
              UserId: loginData?.userInformation?.UserId,
              SiteId: siteId,
              projectName: projectName,
              ProjectType: projectInfo?.type === "" ? 0 : projectInfo?.type,
              ProjectWebsite: projectInfo?.website,
              Description: projectInfo?.description,
              IsActive: projectInfo?.activeProject,
              RecordStatusId: 1,
              ModifiedBy: loginData?.userInformation?.UserId
            }
          ]
        };
        const getResponse = await Postrequestcall(
          SAVE_USER_SITES_PROJECTS,
          projObj,
          loginData?.accessToken
        );
        if (!getResponse?.data?.status) {
          alert(getResponse?.data?.message ?? "Something went wrong. Please try again later.");
          return;
        }
        // if (getResponse?.status === 201) {
        projectDetail = getResponse?.data?.data[0]?.objData;
        let getObj = {
          ...getResponse?.data?.data[0]?.objData,
          projectId: getResponse?.data?.data[0]?.objData?.id,
          type: "add",
          from: showMapmodal?.from
        };
        dispatch(setSelectedProjectdata(getObj));
        // }
      } catch (error) {
        alert(error?.response?.data?.message ?? "Something went wrong. Please try again later.");
      }
    }
    await saveProjectPictures(projectDetail);
  };

  const saveProjectPictures = async (projectDetail) => {
    try {
      if (imagelist?.length > 0) {
        const getObj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: true,
          ReturnRecordError: false,
          SaveList: [
            {
              Id: 0,
              FormatTypeId: 1,
              PostedByUserId: loginData?.userInformation?.UserId,
              AppId: 24,
              AppRecordId: projectDetail?.id,
              Message: "<<<picture>>>",
              Reported: false,
              ModifiedBy: loginData?.userInformation?.UserId
            }
          ]
        };
        const savePostResult = await Postrequestcall(SAVE_POSTS, getObj, loginData?.accessToken);
        if (savePostResult.status === 201) {
          let getId = savePostResult?.data?.data[0]?.objData?.id;
          await Promise.all(
            imagelist.map(async (item) => {
              let pictureDate = "";
              let fileDate = item?.file?.lastModifiedDate ?? null;
              if (fileDate) {
                pictureDate = moment(fileDate, "YYYY:MM:DD HH:mm:ss").format("YYYY-MM-DD hh:mm A");
              }
              const formData = new FormData();
              formData.append("Id", 0);
              formData.append("PostId", getId ?? 0);
              formData.append("ModifiedBy", loginData?.userInformation?.UserId);
              formData.append("Pictures", item);
              formData.append("PictureDateTime", pictureDate);
              formData.append("GPSLatitude", 0);
              formData.append("GPSLongitude", 0);
              formData.append("GPSAltitude", 0);
              await Fileuploadrequestcall(SAVE_POST_PICTURE, formData, loginData?.accessToken);
            })
          );
        }
      }
      if (showMapmodal?.from === "earn-rewards") {
        let mapModal = {
          open: false,
          from: "",
          select: ""
        };
        dispatch(setShowaddproject(false));
        dispatch(setShowmapmodal(mapModal)); // Close map modal
        return;
      } else if (
        showMapmodal?.from === "company-detail" ||
        showMapmodal?.from === "manufacture-detail"
      ) {
        await saveProjectForCompany(projectDetail);
        return;
      } else if (showMapmodal?.from === "product-detail") {
        saveProjectforProduct(projectDetail);
        return;
      } else if (projectInfo?.addProfile) {
        dispatch(setShowaddproject(false));
        if (localStorage.getItem("onboardingPending") !== "true") {
          dispatch(setShowaddexperience(true));
        }
      } else if (projectInfo?.latitude === 0 && projectInfo?.longitude === 0) {
        dispatch(setShowaddproject(false)); // From no location site add project
        navigate("/project/" + projectDetail?.id);
      } else {
        setProjectinfo({ ...initialProjectInfo }); // Update the project list of site detail
        dispatch(setSiteprojects(true));
        dispatch(setShowaddproject(false));
      }
    } catch (error) {
      console.log("saveProjectPictures-> Error While Saving Project Pictures: ", error);
    } finally {
    }
  };

  const onUpdateSiteName = async () => {
    try {
      setConfirmationModalOpen(false);
      setIsLoading(true);
      const siteObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: projectInfo?.siteId,
            Name: projectInfo?.projectName,
            Address: projectInfo?.address,
            City: projectInfo?.city,
            Province: projectInfo?.province,
            PostalCode: projectInfo?.postalCode,
            Country: projectInfo?.country,
            Latitude: projectInfo?.latitude,
            Longitude: projectInfo?.longitude,
            RecordStatusId: 1,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      let saveSiteResult = await Postrequestcall(SAVE_SITES, siteObj, loginData?.accessToken);
      await saveSitesAndProjects(
        saveSiteResult?.data?.data[0]?.objData?.id ?? 0,
        projectInfo?.projectName,
        projectInfo?.projectName
      );
      if (showMapmodal?.from === "earn-rewards") {
        let mapModal = {
          open: false,
          from: "",
          select: ""
        };
        dispatch(setShowmapmodal(mapModal)); // Close map modal
      }
    } catch (error) {
      console.log("onUpdateSiteName-> Error While Saving Site Name: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const saveProjectforProduct = async (projectDetail) => {
    try {
      let getProductid = window.location.pathname.split("/").pop();
      const obj = {
        UserId: Number(loginData?.userInformation?.UserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            ProductId: getProductid,
            ProjectId: projectDetail?.id,
            ModifiedBy: Number(loginData?.userInformation?.UserId),
            RecordStatusId: 1
          }
        ]
      };
      let getResponse = await Postrequestcall(SAVE_PROJECTS_PRODUCTS, obj, loginData?.accessToken);
      if (getResponse.status === 201) {
        closeMapmodal(projectDetail);
      }
    } catch (error) {}
  };

  const saveProjectForCompany = async (projectDetail) => {
    try {
      let getCompanyid = window.location.pathname.split("/").pop();
      const saveObj = [
        {
          Id: 0,
          ProjectId: projectDetail?.id,
          CompanyId: Number(getCompanyid),
          ModifiedBy: Number(loginData?.userInformation?.UserId)
        }
      ];
      let getResponse = await Postrequestcall(
        SAVE_PROJECTS_COMPAINES,
        saveObj,
        loginData?.accessToken
      );
      if (getResponse.status === 201) {
        if (projectInfo?.addProfile) {
          dispatch(setShowaddproject(false));
          if (localStorage.getItem("onboardingPending") !== "true") {
            dispatch(setShowaddexperience(true));
          }
          dispatch(
            setSelectedProjectdata({
              ...projectDetail,
              // mainPictureUrl: project?.pictureList?.length > 0 ? project?.pictureList[0]?.pictureUrl : "",
              siteName: projectInfo?.siteName,
              address: projectInfo?.address,
              projectId: projectDetail?.id,
              from:
                showMapmodal?.from === "company-detail"
                  ? "company-detail"
                  : showMapmodal?.from === "product-detail"
                    ? "product-detail"
                    : "manufacture-detail"
            })
          );
        } else {
          closeMapmodal(projectDetail);
        }
      }
    } catch (error) {
      console.log("saveProjectForCompany-> Error When Saving Project For Company: ", error);
    }
  };

  const closeMapmodal = (projectDetail) => {
    let mapModal = {
      open: false,
      from: "",
      select: ""
    };
    dispatch(setShowmapmodal(mapModal)); // Close the map modal
    dispatch(setShowaddproject(false));
    dispatch(
      setSelectedProjectdata({
        ...projectDetail,
        // mainPictureUrl: project?.pictureList?.length > 0 ? project?.pictureList[0]?.pictureUrl : "",
        siteName: projectInfo?.siteName,
        address: projectInfo?.address,
        projectId: projectDetail?.id,
        from:
          showMapmodal?.from === "company-detail"
            ? "company-detail"
            : showMapmodal?.from === "product-detail"
              ? "product-detail"
              : "manufacture-detail"
      })
    );
  };

  const closeAddproject = () => {
    dispatch(setShowaddproject(false));
    dispatch(setProjectimages([]));
    setImagelist([]);
    setProjectinfo({}); // Clear the state using the spread operator
  };

  const chooseSite = () => {
    let mapModal = {
      open: true,
      from: showMapmodal?.from,
      select: "site"
    };
    dispatch(setShowmapmodal(mapModal));
  };

  return (
    <>
      <PromptModal
        isOpen={confirmationModalOpen}
        onClose={() => setConfirmationModalOpen(false)}
        title={TEXT_PROJECT_NAME_SAME_AS_SITE}
        desc=""
        blueButtonText={false}
        onBlueButtonClick={false}
        blueButtonText2={BUTTON_TEXT_OK}
        onBlueButtonClick2={() => onUpdateSiteName()}
      />
      <Modal open={showAddproject ?? false} closeAfterTransition>
        <Box className="user-modal-responsive">
          {isLoading ? (
            <Box sx={{ height: "450px" }}>
              <Loader />
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between"
                }}>
                <Typography variant="h6">{TEXT_ADD_PROJECT}</Typography>
                <Stack direction={"row"}>
                  <IconButton onClick={() => closeAddproject()}>
                    <CloseIcon />
                  </IconButton>
                  <IconButton
                    color="primary"
                    loading={isLoading}
                    disabled={projectInfo?.projectName?.trim() === ""}
                    onClick={() => onSaveProject()}>
                    <SaveIcon />
                  </IconButton>
                </Stack>
              </Box>
              <Stack spacing={isSmallScreen ? 1 : 1.5}>
                {imagelist?.length !== 0 ? (
                  <>
                    <Box sx={{ flexGrow: 1 }}>
                      <Grid container spacing={1} sx={{ alignItems: "center" }}>
                        <Grid
                          size={{ xs: 3.5, sm: 2.8, md: 2.8 }}
                          sx={{ height: isSmallScreen ? 90 : 130 }}>
                          <Button
                            sx={{
                              width: "100%",
                              height: "100%",
                              color: "GrayText",
                              borderRadius: "10px",
                              backgroundColor: "lightgray",
                              boxShadow: "none",
                              textAlign: "center",
                              p: 0
                            }}
                            variant="text"
                            size="small"
                            component="label">
                            <ImageIcon /> {TEXT_ADD_PICTURES}
                            <input
                              id="timeSheetPicture-upload"
                              type="file"
                              multiple
                              accept="image/*"
                              onChange={(e) => handleChooseFile(e)}
                              hidden
                            />
                          </Button>
                        </Grid>

                        <Grid
                          size={{ xs: 8.5, sm: 9.2, md: 9.2 }}
                          sx={{ height: isSmallScreen ? 90 : 130 }}>
                          <ImageList
                            gap={7.5}
                            sx={{
                              width: "100%",
                              height: "100%",
                              margin: 0,
                              padding: 0,
                              flexWrap: "nowrap",
                              overflowX: "auto",
                              display: "flex",
                              scrollbarWidth: "none",
                              borderRadius: "10px",
                              backgroundColor: "white"
                            }}>
                            {imagelist.map((picItem, picIndex) => (
                              picItem?.name?<ImageListItem
                                key={picIndex}
                                sx={{ minWidth: isSmallScreen ? 90 : 130 }}>
                                <img
                                  // src={picItem?.id ? picItem?.name : URL.createObjectURL(picItem)}
                                  src={picItem?.name ? URL.createObjectURL(picItem):""}
                                  // src={picItem?.id ?? picItem?.name}
                                  style={{
                                    borderRadius: 10,
                                    width: isSmallScreen ? 90 : 130,
                                    height: isSmallScreen ? 90 : 130,
                                    objectFit: "cover"
                                  }}
                                  alt="Expenses"
                                  loading="lazy"
                                />
                                <ImageListItemBar
                                  sx={{ background: "none", padding: 1 }}
                                  position="top"
                                  actionIcon={
                                    <IconButton
                                      onClick={() => onDeletePicturePressed(picItem, picIndex)}
                                      size="small"
                                      sx={{
                                        color: "white",
                                        backgroundColor: "rgba(0,0,0,0.3)"
                                      }}>
                                      <CloseIcon fontSize="small" />
                                    </IconButton>
                                  }
                                  actionPosition="right"
                                />
                              </ImageListItem>:null
                            ))}
                          </ImageList>
                        </Grid>
                      </Grid>
                    </Box>
                  </>
                ) : (
                  <Button
                    sx={{
                      width: "100%",
                      color: "GrayText",
                      height: 100,
                      backgroundColor: "lightgray",
                      boxShadow: "none"
                    }}
                    startIcon={<ImageIcon />}
                    variant="contained"
                    size="small"
                    component="label">
                    {TEXT_ADD_PICTURES}
                    <input
                      id="timeSheetPicture-upload"
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={(e) => handleChooseFile(e)}
                      hidden
                    />
                  </Button>
                )}

                <Grid container spacing={1} rowSpacing={0.5}>
                  <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <TextField
                      size="medium"
                      type="text"
                      variant="outlined"
                      label={TEXT_SITE_NAME_PLACEHOLDER}
                      fullWidth
                      style={{ marginBottom: "5px" }}
                      name="siteName"
                      disabled={selectedSite?.name ? true : false}
                      value={projectInfo?.siteName}
                      helperText={
                        projectInfo?.address !== ""
                          ? projectInfo?.address
                          : projectInfo?.latitude !== 0 &&
                              projectInfo?.latitude !== null &&
                              projectInfo?.longitude !== 0 &&
                              projectInfo?.longitude !== null
                            ? `(${projectInfo?.latitude},${projectInfo?.longitude})`
                            : projectInfo?.siteName !== ""
                              ? TEXT_NO_LOCATION
                              : ""
                      }
                      onChange={(e) => addSitechange(e)}
                      sx={{
                        mb: 1, // Adjust margin-bottom
                        "& .MuiFormHelperText-root": {
                          margin: "10px 0px 0px 0px",
                          padding: 0
                        }
                      }}
                    />
                    {projectInfo?.latitude === 0 && projectInfo?.longitude === 0 && (
                      <>
                        <Typography style={{ textAlign: "center", color: "#8d8d8d" }}>
                          {TEXT_OR}
                        </Typography>
                        <Stack>
                          <Button variant="text" onClick={() => chooseSite()}>
                            {" "}
                            {TEXT_CHOOSE_SITE}
                          </Button>
                        </Stack>
                      </>
                    )}
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <TextField
                      size="medium"
                      type="text"
                      variant="outlined"
                      label={TEXT_PROJECT_NAME_REQUIRED}
                      fullWidth
                      style={{ marginBottom: "5px" }}
                      name="projectName"
                      value={projectInfo?.projectName}
                      onChange={(e) => addSitechange(e)}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <FormControl size="medium" fullWidth>
                      <InputLabel id="mutiple-select-label">{TEXT_TYPE}</InputLabel>
                      <Select
                        labelId="mutiple-select-label"
                        variant="outlined"
                        value={projectInfo?.type}
                        label={TEXT_TYPE}
                        onChange={(e) => onTypechange(e)}
                        MenuProps={MenuProps}
                        sx={{ p: 0 }}>
                        {siteType.map((option) => {
                          return (
                            <MenuItem key={option.id} value={option.id}>
                              <ListItemText primary={option.name} />
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <TextField
                      size="medium"
                      type="text"
                      variant="outlined"
                      label={TEXT_INPUT_LABEL_WEBSITE}
                      fullWidth
                      style={{ marginBottom: "5px" }}
                      name="website"
                      value={projectInfo?.website}
                      onChange={(e) => addSitechange(e)}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={projectInfo?.activeProject}
                          onChange={(e) => onCheckboxchange(e)}
                          name="activeProject"
                        />
                      }
                      label={TEXT_ACTIVE_PROJECT}
                    />
                    {showMapmodal?.from === "earn-rewards" ? (
                      <></>
                    ) : (
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={projectInfo?.addProfile}
                            disabled={showMapmodal?.from === "experience" ? true : false}
                            onChange={(e) => onCheckboxchange(e)}
                            name="addProfile"
                          />
                        }
                        label={TEXT_ADD_TO_MY_PROFILE}
                      />
                    )}
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                    <TextField
                      label={TEXT_DESCRIPTION}
                      onChange={(e) => addSitechange(e)}
                      slotProps={{
                        input: {
                          rows: 5,
                          multiline: true,
                          inputComponent: "textarea"
                        }
                      }}
                      name="description"
                      rows={4}
                      variant="outlined"
                      fullWidth
                      value={projectInfo?.description}
                    />
                  </Grid>
                </Grid>
              </Stack>
            </>
          )}
        </Box>
      </Modal>
    </>
  );
}
